module.exports = __webpack_public_path__ + "static/media/0.de6116f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/buy/0.png
// module id = 1088
// module chunks = 0